var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 4.16667H3.33073V15.8333L11.0741 8.08833C11.2303 7.93211 11.4423 7.84434 11.6632 7.84434C11.8842 7.84434 12.0961 7.93211 12.2524 8.08833L16.6641 12.5083V4.16667ZM1.66406 3.3275C1.66559 3.10865 1.75315 2.89918 1.90782 2.74435C2.0625 2.58951 2.27188 2.50175 2.49073 2.5H17.5041C17.9607 2.5 18.3307 2.87083 18.3307 3.3275V16.6725C18.3292 16.8914 18.2416 17.1008 18.087 17.2557C17.9323 17.4105 17.7229 17.4983 17.5041 17.5H2.49073C2.27141 17.4998 2.06114 17.4125 1.90614 17.2573C1.75113 17.1022 1.66406 16.8918 1.66406 16.6725V3.3275ZM6.66406 9.16667C6.22203 9.16667 5.79811 8.99107 5.48555 8.67851C5.17299 8.36595 4.9974 7.94203 4.9974 7.5C4.9974 7.05797 5.17299 6.63405 5.48555 6.32149C5.79811 6.00893 6.22203 5.83333 6.66406 5.83333C7.10609 5.83333 7.53001 6.00893 7.84257 6.32149C8.15513 6.63405 8.33073 7.05797 8.33073 7.5C8.33073 7.94203 8.15513 8.36595 7.84257 8.67851C7.53001 8.99107 7.10609 9.16667 6.66406 9.16667Z",
    fill: "#85858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.dcd8791ea3a3de9358eeabdb6f43cecd.svg";
export { ForwardRef as ReactComponent };